const SendInvitationResultTypes = Object.freeze({
  SUCCESS: 1,
  RECIPIENT_IS_REGISTERED_USER: 2,
  RECIPIENT_IS_OWNER_OR_COLLABORATOR: 3,
});

export default SendInvitationResultTypes;
